import { tokens } from '@equinor/eds-tokens';
import { button } from './button.js';
import mergeDeepRight from '../../../node_modules/.pnpm/ramda@0.29.0/node_modules/ramda/es/mergeDeepRight.js';

var _tokens$colors$intera = tokens.colors.interactive,
  primaryColor = _tokens$colors$intera.primary__resting.rgba,
  primaryHoverAltColor = _tokens$colors$intera.primary__hover_alt.rgba,
  secondaryColor = _tokens$colors$intera.secondary__resting.rgba,
  secondaryHoverColor = _tokens$colors$intera.secondary__link_hover.rgba,
  secondaryHoverAltColor = _tokens$colors$intera.secondary__highlight.rgba,
  dangerColor = _tokens$colors$intera.danger__resting.rgba,
  dangerHoverColor = _tokens$colors$intera.danger__hover.rgba,
  dangerHoverAltColor = _tokens$colors$intera.danger__highlight.rgba,
  _tokens$clickbounds = tokens.clickbounds,
  clicboundHeight = _tokens$clickbounds.default__base,
  compactClickboundHeight = _tokens$clickbounds.compact__standard,
  shape = tokens.shape,
  focusOutlineWidth = tokens.interactions.focused.width;
var primary = mergeDeepRight(button, {
  height: shape.icon_button.minHeight,
  width: shape.icon_button.minWidth,
  typography: {
    color: primaryColor
  },
  border: {
    width: '0px',
    radius: '50%'
  },
  background: 'transparent',
  spacings: {
    left: '0',
    right: '0'
  },
  clickbound: {
    width: clicboundHeight,
    offset: {
      top: '0',
      left: "".concat((parseInt(clicboundHeight) - parseInt(shape.icon_button.minWidth)) / 2, "px")
    }
  },
  states: {
    hover: {
      background: primaryHoverAltColor,
      border: {
        width: '0px',
        radius: '50%'
      }
    },
    disabled: {
      background: 'transparent',
      border: {
        color: 'transparent'
      }
    },
    focus: {
      outline: {
        offset: "-".concat(parseInt(focusOutlineWidth), "px")
      }
    }
  },
  modes: {
    compact: {
      height: shape._modes.compact.icon_button.minHeight,
      width: shape._modes.compact.icon_button.minWidth,
      clickbound: {
        width: compactClickboundHeight,
        offset: {
          top: '0',
          left: "".concat((parseInt(compactClickboundHeight) - parseInt(shape._modes.compact.icon_button.minWidth)) / 2, "px")
        }
      }
    }
  }
});
var secondary = mergeDeepRight(primary, {
  typography: {
    color: secondaryColor
  },
  states: {
    hover: {
      background: secondaryHoverAltColor,
      typography: {
        color: secondaryHoverColor
      }
    }
  }
});
var danger = mergeDeepRight(primary, {
  typography: {
    color: dangerColor
  },
  states: {
    hover: {
      background: dangerHoverAltColor,
      typography: {
        color: dangerHoverColor
      }
    }
  }
});

export { danger, primary, secondary };
